import type { ClaimsDataType, RREDataType } from "types/DataTypes";

import type { InfoPillFields } from "../InfoPillTypes";
import { NOT_AVAILABLE } from "../InfoPillTypes";

export const getClaimInfoPillData = (claim: ClaimsDataType): InfoPillFields => {
  if (!claim) return {};

  return {
    Client: {
      value: claim.rre_name || NOT_AVAILABLE,
      action: {
        type: "drawer" as const,
        drawerType: "clientInfo" as const,
      },
    },
    Claimant: {
      value: claim.injured_party_full_name || NOT_AVAILABLE,
    },
    "Medicare status": {
      value: claim.is_medicare_beneficiary ? "Beneficiary" : "Not Beneficiary",
    },
    "Date of injury": {
      value: claim.cms_date_of_incident || NOT_AVAILABLE,
    },
    Adjuster: {
      value: claim.adjuster || NOT_AVAILABLE,
    },
    NSA: {
      value: claim.next_scheduled_action_verbose || NOT_AVAILABLE,
      classNames: "status blue",
    },
  };
};

export const getRREInfoPillData = (rre: RREDataType): InfoPillFields => {
  if (!rre) return {};

  return {
    "RRE Name": {
      value: rre.name || NOT_AVAILABLE,
    },
    "RRE ID": {
      value: rre.rre_id.toString() || NOT_AVAILABLE,
    },
    "Client Name": {
      value: rre.rre_profile?.client_name || NOT_AVAILABLE,
    },
  };
};
